<template>
  <div class="product-inform-availability">
    <div class="product-inform-availability__title">
      <span>{{ result.messages.title }}</span>
    </div>
    <p class="product-inform-availability__text">{{ result.messages.description }}</p>
    <DefButtonPrimary @click="modal.hide()"> ОК </DefButtonPrimary>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import useModal from '@use/useModal/useModal';

const modal = useModal();

const { result } = defineProps(['result']);
</script>

<script>
export default {
  name: 'ProductInformAvailability',
};
</script>

<style lang="scss" scoped>
.product-inform-availability {
  display: flex;
  flex-direction: column;
  &__title {
    font-weight: 600;
    font-size: rem(18);
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 24px;
  }
  &__text {
    font-weight: 500;
    font-size: rem(14);
    line-height: 130%;
    margin-bottom: 16px;
  }
  &__error {
    color: var(--color-red);
  }
  :deep(.def-button-primary) {
    margin-top: 8px;
  }
}
</style>
